// import Store from 'store/store';
import parseQueryString from 'utils/parseQueryString';

const qs = parseQueryString();

let apiBase = 'https://api.cms.universalpictures.com';
if (__IS_LOCAL__ || __IS_DEMO__) {
	apiBase = 'https://api.cms.dev.cmspow.com';
	if (qs.localserver) apiBase = 'http://localhost:1238';
} else {
	const hostname = typeof window !== 'undefined' ? location.origin : '';
	if (hostname.includes('stage.cms.universalpictures.com')) {
		apiBase = 'https://stage.api.cms.universalpictures.com';
	}
	if (hostname.includes('cms.qa.nbcunip.com')) {
		apiBase = 'https://api.cms.qa.nbcunip.com';
	}
}

export { apiBase as API_ORIGIN };

export async function request(path, options = {}) {
	let responseFormat = options.format || 'json';
	delete options.format;
	const onError = options.onError;
	delete options.onError;

	let url = new URL(path, apiBase);
	if (options.qs) {
		url.search = new URLSearchParams(options.qs).toString();
		delete options.qs;
	}

	if ((__IS_LOCAL__ || __IS_DEMO__) && qs['bypass-login']) {
		options.headers = options.headers || {};
		options.headers['Authorization'] = options.headers['Authorization'] || 'Bearer %UniCMSPowsterThundrKey%!';
	}

	const _fetch = options.engine || fetch;
	delete options.engine;
	const credentials = options.credentials ?? (url.origin === apiBase ? 'include' : 'same-origin');
	let res = await _fetch(url.href, { ...options, credentials });
	// if (res.status === 401) {
	// 	// 401 = Unauthorized
	// 	// Login logic here ? Or trigger some kind of event ?
	// 	// Store.get().set({ user: null });
	// 	// showLogin();
	// }
	if (!res.ok) {
		onError?.[res.status]?.(res);
		let error = new Error(res.status);
		error.code = res.status;
		error.response = res;
		throw error;
	}
	return res[responseFormat]?.();
}

export async function post(path, body, options) {
	let { asFormData, headers, ...rest } = options || {};
	// For form data: don't specify content-type (can't set to multipart/form-data ourselves because we need a "boundary" value to be set automatically by the browser)
	if (!asFormData) {
		headers = { ...headers, 'Content-Type': 'application/json' };
	}
	return request(
		path,
		{
			method: 'POST',
			...rest,
			body: !body || typeof body === 'string' || asFormData ? body : JSON.stringify(body),
			headers,
		}
	);
}

export async function patch(path, body, options) {
	return request(
		path,
		{
			method: 'PATCH',
			...options,
			body: !body || typeof body === 'string' ? body : JSON.stringify(body),
			headers: { ...options?.headers, 'Content-Type': options?.headers?.['Content-Type'] || 'application/json' },
		}
	);
}

export async function del(path, body, options) {
	return request(
		path,
		{
			...options,
			method: 'DELETE',
			body: !body || typeof body === 'string' ? body : JSON.stringify(body),
			headers: { ...options?.headers, 'Content-Type': options?.headers?.['Content-Type'] || 'application/json' },
		}
	);
}

export const getAllMovies = (options) => request('/movies/all', options);
export const getAllSections = (options) => request('/sections/all', options);
export const getAllUsers = () => request('/users/all');
export const getAllMedia = () => request('/media/all');
export const getMediaByURL = (url) => request('/media/by-url', { qs: { url } });
